// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__13U_b","buttons":"RemoveExpirationActionButtons_buttons__2e8Ph"};